// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"660992c2","453":"45884f98","455":"516c1294","500":"f05c6ab9","531":"e426204d","977":"e4ea2986"}[chunkId] + ".chunk.js";
};